export default __webpack_public_path__ + "assets/trophy.30d2ec3e.svg";